export { default } from "./AppAvatar";
